import React from "react";
import PDFHeaderV from "../../PDFHeaderV/PDFHeader";

const ROWS_NUMBER = 12;

// Using a class component, everything works without issue
export class ValidationPDF extends React.PureComponent {
    render() {
        return (
            <div className="PDFValidateurContent">
                <div className="recommandationsPDF">
                    <h1 className="titrePDF">IV - VALIDATION</h1>

                    <div
                        style={{
                            marginLeft: "50px",
                            marginRight: "50px",
                            marginTop: "40px",
                        }}
                    >
                        <table className="table table-bordered table-sm align-middle">
                            <thead className="theadValidation">
                                <tr>
                                    <th scope="col">VALIDATEUR</th>
                                    <th scope="col">DATE</th>
                                    <th scope="col">SIGNATURE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.from(Array(ROWS_NUMBER), (e, i) => {
                                    return (
                                        <tr key={i}>
                                            <th style={{ height: "65px" }}></th>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="pagebreak"></div>
            </div>
        );
    }
}
